import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Fragment } from 'react';
import { useComponent, useDataSelector, useDebugHydration, useDoHydrateComponent } from '@uswitch/ev-utils/lib/context/selectors';
import SmartContainer from '../helpers/smart-container2';
import ModMarker, { displayModMarker } from '../helpers/module-marker';
import ClientErrorBoundary from './error-boundary';
import { ConditionalWrapper } from '@uswitch/ev-utils/lib/conditional-wrapper';
import DontHydrate, { RedWrapper } from '@uswitch/ev-utils/lib/dont-hydrate';
import { useTrackModule, ComponentTrackingContext } from '@uswitch/ev-utils/lib/component-events';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";

var Module = function Module(props) {
  var _props$sys;

  var _useComponent = useComponent(props),
      _useComponent2 = _slicedToArray(_useComponent, 4),
      err = _useComponent2[0],
      C = _useComponent2[1],
      wrapper = _useComponent2[2],
      features = _useComponent2[3];

  var _useDataSelector = useDataSelector(['dates'], {}),
      publishDate = _useDataSelector.publishDate,
      updatedDate = _useDataSelector.updatedDate;

  var id = props.id || ((_props$sys = props.sys) === null || _props$sys === void 0 ? void 0 : _props$sys.id);
  var doHydrate = useDoHydrateComponent(id);
  var debugHydration = useDebugHydration();

  var _useTrackModule = useTrackModule(props),
      ref = _useTrackModule.ref,
      trackComponent = _useTrackModule.trackComponent,
      trackProps = _useTrackModule.trackProps; // TODO: Handle errors in finding the component


  if (err) {
    console.log({
      err: err
    });
    return null;
  }

  var additionalProps = {};

  if (features !== null && features !== void 0 && features.localDates) {
    var _props$sys2, _props$sys3;

    additionalProps.localDates = {
      dateCreated: props === null || props === void 0 ? void 0 : (_props$sys2 = props.sys) === null || _props$sys2 === void 0 ? void 0 : _props$sys2.createdAt,
      dateUpdated: props === null || props === void 0 ? void 0 : (_props$sys3 = props.sys) === null || _props$sys3 === void 0 ? void 0 : _props$sys3.updatedAt
    };
  }

  if (features !== null && features !== void 0 && features.globalDates) {
    additionalProps.globalDates = {
      dateCreated: publishDate,
      dateUpdated: updatedDate
    };
  }

  return _jsxs(Fragment, {
    children: [displayModMarker() && _jsx(ModMarker, {
      entity: props
    }), _jsx(ConditionalWrapper, {
      condition: !doHydrate,
      wrapper: DontHydrate,
      otherwise: debugHydration ? RedWrapper : undefined,
      children: _jsx(SmartContainer, {
        wrapper: wrapper,
        spacing: props.spacing,
        parentContentType: props.parentContentType,
        ref: ref,
        "data-component-tracking": JSON.stringify(trackProps),
        children: _jsx(ClientErrorBoundary, {
          children: _jsx(ComponentTrackingContext.Provider, {
            value: trackComponent,
            children: _jsx(C, _objectSpread(_objectSpread({}, props), additionalProps))
          })
        })
      })
    })]
  });
};

export default Module;